export default {
  placeholder: 'Vyberte datum…',
};
